import '../../scss/pages/blogs.scss';